export const projectsName = {
  firstName: ' Nom del projecte',

  secondName: ' Nom del projecte',
};

export const portfolioText =
  `Un cop l'ajuntament hagi atorgat un certificat de finalització a la casa i hagi estat aprovada pel seu agent, es pot recosir al sofà acuradament elegit i admirar la seva nova llar. El període de garantia de defectes, en el qual el contractista està obligat a reparar qualsevol inconvenient, durarà aproximadament 12 mesos.`;